<template>
	<CCard>
		<CCardHeader> Produits </CCardHeader>
		<CCardBody>
			<template
				v-if="
					(order.status === 'order.pending' || order.status === 'order.paid') &&
					order.concept === 'order.colikado'
				">
				<CRow>
					<CCol col="4">
						<CInput
							ref="formSlipNumber"
							v-model="formSlipNumber"
							name="slip"
							label="Numéro de bordereau" />
					</CCol>

					<CCol col="4">
						<div class="form-group">
							<label>Produit</label>
							<GTreeView
								input-name="product"
								placeholder="Rechercher un produit"
								:multiple="false"
								v-on:update:selected="data => (formProductId = data)"
								:default-options="true"
								:load-options="loadProducts"
								:async="true" />
						</div>
					</CCol>

					<CCol col="4">
						<CInput v-model="formWeight" name="weightNet" label="Poids" />
					</CCol>

					<CCol col="6">
						<div class="form-group">
							<label>Point de vente</label>
							<GTreeView
								input-name="soldPts"
								placeholder="Point de vente"
								:multiple="false"
								v-on:update:selected="data => (formPointOfSale = data)"
								:value="formPointOfSale"
								:default-options="true"
								:load-options="loadSalePoints"
								:async="true" />
						</div>
					</CCol>

					<CCol col="6">
						<div class="form-group">
							<label>Point de dépôt</label>
							<GTreeView
								input-name="dropoffPts"
								placeholder="Point de dépôt"
								:multiple="false"
								v-on:update:selected="data => (formPointOfDepot = data)"
								:default-options="true"
								:load-options="loadDropoffPoints"
								:async="true" />
						</div>
					</CCol>

					<CCol col="6">
						<CInput
							v-model="formDeclaredPrice"
							name="declaredPrice"
							label="Valeur du contenu (max 45€)" />
					</CCol>

					<CCol col="12">
						<CSelect
							label="Description du contenu"
							:options="formCompoOptions"
							v-on:change="onFormCompoOptionSelection" />
					</CCol>
					<CCol col="12" v-if="isFormComponentNameVisible">
						<CInput
							v-model="formComponentName"
							name="components[0].name"
							label="Description du contenu" />
					</CCol>
				</CRow>
				<CRow>
					<CCol col="6">
						<CButton color="primary" @click="addSubmit">Ajouter</CButton>
					</CCol>
				</CRow>
			</template>

			<GDataTableRemote
				ref="mainTable"
				:remote-url="order['@id'] + '/order_items'"
				:fields="fields"
				:items-per-page="10"
				class="mt-4"
				hover
				striped
				sorter
				columnFilter
				pagination>
				<template #receiverAddress="{ item }">
					<td v-if="item.receiverAddress">
						{{ item.receiverAddress.firstName }} {{ item.receiverAddress.lastName }}
						<br />
						{{ item.receiverAddress.postalCode }}, {{ item.receiverAddress.city }}

						<a class="text-center icon-space ml-3" href="#" @click.prevent="editAddress(item)">
							<CIcon name="cil-pencil"></CIcon>
						</a>
					</td>
					<td v-else>
						<CIcon name="cil-ban" style="color: red" />
						<a class="text-center icon-space ml-3" href="#" @click.prevent="editAddress(item)">
							<CIcon name="cil-pencil"></CIcon>
						</a>
					</td>
				</template>

				<template #priceTTC="{ item }">
					<td>{{ item.priceTTC }} €</td>
				</template>

				<template #declaredPrice="{ item }">
					<td>{{ item.declaredPrice }} €</td>
				</template>

				<template #state="{ item }">
					<td>
						<CBadge :color="statusColor[item.state]">{{ statusTranslation[item.state] }}</CBadge>
					</td>
				</template>

				<template #action="{ item }">
					<td class="text-center" style="white-space: nowrap">
						<template
							v-if="
								item.receiverAddress &&
								item.price &&
								item.slip &&
								item.slip.depotPts &&
								item.slip.salePts &&
								(order.status === 'order.complete' ||
									order.status === 'order.paid' ||
									order.status === 'order.admin_authorized')
							">
							<CIcon name="cil-check" style="color: green" />
						</template>
						<template v-else>
							<CIcon name="cil-ban" style="color: red" />
						</template>

						<a
							class="text-center icon-space ml-3"
							href="#"
							@click.prevent="printLabel(item)"
							v-if="
								order.concept !== 'order.colikado' ||
								(item.receiverAddress &&
									item.price &&
									item.slip &&
									item.slip.depotPts &&
									item.slip.salePts &&
									(order.status === 'order.complete' ||
										order.status === 'order.paid' ||
										order.status === 'order.admin_authorized'))
							">
							<CIcon name="cil-print" />
						</a>
						<a class="text-center icon-space ml-3" href="#" @click.prevent="editOrderItem(item)">
							<CIcon name="cil-pencil" />
						</a>
						<a class="text-center icon-space ml-3" href="#" @click.prevent="removeItem(item)">
							<CIcon name="cil-trash" />
						</a>
					</td>
				</template>
			</GDataTableRemote>
		</CCardBody>

		<edit-address ref="editAddress" :customer="customer" v-on:refresh="refresh" />
		<edit-order-item ref="editOrderItem" v-on:refresh="refresh" />
		<print-label-modal ref="printLabelModal" v-on:refresh="refresh" />
	</CCard>
</template>

<script>
	import GTreeView from '../../../../../components/ghostlexly-components/GTreeView';
	import GDataTableRemote from '../../../../../components/ghostlexly-components/GDataTableRemote';
	import EditAddress from './edit-address';
	import EditOrderItem from './edit-order-item';
	import PrintLabelModal from '../../../../../components/modals/print-label-modal';

	export default {
		name: 'orderitem-card',

		components: {
			PrintLabelModal,
			EditOrderItem,
			EditAddress,
			GDataTableRemote,
			GTreeView,
		},

		props: {
			order: Object,
			customer: Object,
		},

		data() {
			return {
				isSlipValid: false,
				isFormComponentNameVisible: false,
				formSlipNumber: null,
				formProductId: null,
				formWeight: null,
				formPointOfSale: null,
				formPointOfDepot: null,
				formComponentName: 'Produits locaux',
				formDeclaredPrice: null,
				loading: false,
				statusTranslation: {
					'order_item.pending': 'En attente',
					'order_item.paused': 'En pause',
					'order_item.label_printed': 'Etiquette imprimée',
					'order_item.orphan': 'Dé-scanné',
					'order_item.scanned': 'Etiquette scannée',
					'order_item.shipped': 'Expédié',
					'order_item.refunded': 'Remboursé',
				},
				statusColor: {
					'order_item.pending': 'danger',
					'order_item.paused': 'warning',
					'order_item.label_printed': 'warning',
					'order_item.orphan': 'warning',
					'order_item.scanned': 'success',
					'order_item.shipped': 'success',
					'order_item.refunded': 'warning',
				},
				fields: [
					{ key: 'reference', label: 'N° Colis' },
					{ key: 'state', label: 'Status' },
					{ key: 'slip.identifier', label: 'N° Bordereau' },
					{ key: 'shippingNumber', label: 'N° Suivi' },
					{ key: 'weightNet', label: 'Poids Net' },
					{ key: 'product.name', label: 'Nom' },
					{ key: 'deliveryDate', label: 'Date de livraison', type: 'date' },
					{ key: 'receiverAddress', label: 'Adresse de réception' },
					{ key: 'priceTTC', label: 'Tarif' },
					{ key: 'declaredPrice', label: 'Valeur déclarée' },
					{ key: 'action', filter: false },
				],
				formCompoOptions: [
					{ label: 'Produits locaux', value: 'Produits locaux' },
					{ label: 'Autre', value: 'Autre' },
				],
			};
		},

		mounted() {
			if (
				this.order.status === 'order.pending' &&
				this.order.concept === 'order.colikado' &&
				this.$refs.formSlipNumber
			) {
				this.$refs.formSlipNumber.$el.querySelector('input').focus();
			}
		},

		watch: {
			formSlipNumber(newVal) {
				if (newVal && newVal.length === 11) {
					this.$axios
						.get(`/api/slips/${newVal}`)
						.then(res => {
							this.formPointOfSale = res.data.pointOfSale;
						})
						.catch(() => {
							this.$toast.error(`Le bordereau "${newVal}" est introuvable.`);
						});
				}
			},

			formProductId(newVal) {
				this.$axios.get(newVal).then(res => {
					this.formWeight = res.data.weightNet;
				});
			},
		},

		methods: {
			onFormCompoOptionSelection(event) {
				if (event.target.value === 'Autre') {
					this.isFormComponentNameVisible = true;
					this.formComponentName = null;
				} else {
					this.isFormComponentNameVisible = false;
					this.formComponentName = event.target.value;
				}
			},

			removeItem(item) {
				this.$axios
					.delete(item['@id'])
					.then(() => {
						this.refresh();
					})
					.catch(err => {
						this.$toast.error(err.response.data['hydra:description']);
					});
			},

			printLabel(item) {
				this.$refs.printLabelModal.orderItem = item;
				this.$refs.printLabelModal.showModal = true;
			},

			editOrderItem(item) {
				this.$refs.editOrderItem.orderItem = item;
				this.$refs.editOrderItem.formComponentName =
					item.components.length > 0 ? item.components[0].name : null;
				this.$refs.editOrderItem.formPointOfSale = item.slip.salePts;
				this.$refs.editOrderItem.formPointOfDepot = item.slip.depotPts;
				this.$refs.editOrderItem.formPrice = item.price;
				this.$refs.editOrderItem.showModal = true;
			},

			editAddress(item) {
				this.$refs.editAddress.orderAddressId = item.receiverAddress
					? item.receiverAddress['@id']
					: null;

				if (item.receiverAddress) {
					this.$refs.editAddress.customerAddress = item.receiverAddress;
				} else {
					this.$refs.editAddress.clear();
				}

				this.$refs.editAddress.orderItem = item;
				this.$refs.editAddress.showModal = true;
			},

			async addSubmit() {
				// verify if slip exists
				try {
					await this.$axios.get(`/api/slips/${this.formSlipNumber}`).catch(() => {
						this.$toast.error(`Le bordereau "${this.formSlipNumber}" est introuvable.`);
						throw 'Bordereau introuvable';
					});
				} catch (err) {
					return;
				}

				// update slip depot & sale infos
				try {
					await this.$axios
						.patch(`/api/slips/${this.formSlipNumber}`, {
							salePts: this.formPointOfSale,
							depotPts: this.formPointOfDepot,
						})
						.catch(() => {
							this.$toast.error(`Le bordereau "${this.formSlipNumber}" n'est pas modifiable.`);
							throw 'Bordereau non-modifiable';
						});
				} catch (err) {
					return;
				}

				// add item to order
				this.$axios
					.post('/api/order_items', {
						parentOrder: this.order['@id'],
						slip: `/api/slips/${this.formSlipNumber}`,
						product: this.formProductId,
						weightNet: this.formWeight,
						weightGross: this.formWeight,
						declaredPrice: this.formDeclaredPrice,
						price: 0,
						priceTTC: 0,
						components: [
							{
								name: this.formComponentName,
								weightGross: this.formWeight,
								weightNet: this.formWeight,
								quantity: 1,
								nomenclature: '2008971690',
							},
						],
					})
					.then(res => {
						if (res.status === 201) {
							this.$formDataToApi.clearPrecedentErrors();

							this.formSlipNumber = null;
							this.refresh();
						}
					})
					.catch(err => {
						this.$formDataToApi.responseErrorProcess(err);
					});
			},

			loadProducts({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('search_autocomplete', searchQuery);

					return this.$axios.get(`/api/products?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let label = item.name;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						if (action === 'ASYNC_SEARCH') {
							callback(null, options);
						}
					});
				}
			},

			loadSalePoints({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('search_autocomplete', searchQuery);
					params.append('isPointOfSale', '1');
					params.append('itemsPerPage', '9999');

					return this.$axios.get(`/api/point_of_sales?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let label = `[${item.reference}] ${item.name} - ${item.postalCode}, ${item.city}`;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						if (action === 'ASYNC_SEARCH') {
							callback(null, options);
						}
					});
				}
			},

			loadDropoffPoints({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('search_autocomplete', searchQuery);
					params.append('isPointOfDepot', '1');

					return this.$axios.get(`/api/point_of_sales?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let label = `[${item.reference}] ${item.name} - ${item.postalCode}, ${item.city}`;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						if (action === 'ASYNC_SEARCH') {
							callback(null, options);
						}
					});
				}
			},

			refresh() {
				this.$refs.mainTable.refresh();
				this.$emit('refresh');
			},
		},
	};
</script>
